module.exports = __webpack_public_path__ + "img/full0-min.eec61da9.png";